import { render, staticRenderFns } from "./OrderReportVolume.vue?vue&type=template&id=6de6014c"
import script from "./OrderReportVolume.vue?vue&type=script&lang=js"
export * from "./OrderReportVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports